import { render, staticRenderFns } from "./ProjectInformationFull.vue?vue&type=template&id=2647ecec&"
import script from "./ProjectInformationFull.vue?vue&type=script&lang=js&"
export * from "./ProjectInformationFull.vue?vue&type=script&lang=js&"
import style0 from "./ProjectInformationFull.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2647ecec')) {
      api.createRecord('2647ecec', component.options)
    } else {
      api.reload('2647ecec', component.options)
    }
    module.hot.accept("./ProjectInformationFull.vue?vue&type=template&id=2647ecec&", function () {
      api.rerender('2647ecec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/projects/ProjectInformationFull.vue"
export default component.exports